import { useState } from "react";

const useLanguage = () => {
  const [language, setLanguage] = useState("ptBR");

  return { language, setLanguage };
};

export default useLanguage;
